import * as TYPES from './type';
export default {
  //授课投票添加
  [TYPES.SK_VOTE_ADD](state, { result }) {
    state.SKVoteAdd = result.result
  },
  //授课投票详情
  [TYPES.SK_VOTE_DETAIL](state, { result }) {
    state.SKVoteDetail = result.result
  },
  //授课投票选项
  [TYPES.SK_VOTE_OPTS](state, { result }) {
    state.SKVoteOpts = result.result
  },
}



// WEBPACK FOOTER //
// ./src/store/give-course/vote/mutations.js